import { IHeader } from "@/models/IHeader";
import { IBookmark } from "@/models/IBookmark";
import { LocalStorageHelper } from "./local-storage-helper";

export const isPageBookmarked = (pageId: number) => {
    const header = LocalStorageHelper.getItem<IHeader>('header-info');
    const bookmarksStorage = LocalStorageHelper.getItem<IBookmark[]>(`bookmarks-${header?.memberId}`) as IBookmark[];
    return bookmarksStorage?.some(bookmark => bookmark.id === pageId) ?? false;
};